import axios from 'axios';
import { getValidToken } from './authService';
import { isDemoMode, demoGetPendingInvitations } from '../demo/demoStore';


const API_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(async (config) => {
  const token = await getValidToken(); 
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const sendGroupInvitation = async (groupId, email) => {
  const response = await apiClient.post(`/groups/${groupId}/invite`, { email });
  return response.data;
};

export const getPendingInvitations = async () => {
  if (isDemoMode()) return demoGetPendingInvitations();
  const response = await apiClient.get('/invitations');
  return response.data;
};

export const acceptInvitation = async (token) => {
  const response = await apiClient.post(`/invitations/${token}/accept`);
  return response.data;
};

export const declineInvitation = async (token) => {
  const response = await apiClient.post(`/invitations/${token}/decline`);
  return response.data;
};

export const getGroupInvitations = async (groupId) => {
  const response = await apiClient.get(`/groups/${groupId}/invitations`);
  return response.data;
};